// extracted by mini-css-extract-plugin
module.exports = {"containerAuth":"AuthPage_containerAuth__1Wvy9","loginForm":"AuthPage_loginForm__2mTns"};